import { computed, ref } from "vue";
const useEditMode = () => {
    const isEdit = ref(false);
    const btnText = computed(() => (isEdit.value ? "수정" : "저장"));
    const btnColor = computed(() => (isEdit.value ? "success" : "primary"));
    const setIsEdit = (value) => {
        isEdit.value = value;
    };
    return { isEdit, setIsEdit, btnText, btnColor };
};
export default useEditMode;
